import React from "react";
import { GiftIcon } from "lucide-react";
import { bonuses } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Bonuses() {
  return <section className="bg-white px-0 py-16 sm:px-4 sm:py-20" data-id="element-75" data-mp="1cl6258j3xigj">
      <div className="mx-auto max-w-5xl" data-id="element-76" data-mp="1clpjan0xo2ti">
        <div className="px-4 text-center sm:px-0" data-id="element-77" data-mp="18jkr7sq4ve8z">
          <p className="inline-flex items-center gap-2 rounded-full bg-cta/10 px-4 py-2 text-sm font-extrabold uppercase tracking-wider text-cta-dark" data-id="element-78" data-mp="18l5o3ozx79a0">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="20b0g5tf5xd2d" />
            Today only with my $27 purchase
          </p>
          <h2 className="mt-4 font-serif text-[2rem] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-80" data-mp="1w8dte6xcmic1">
            5 exclusive bonuses — <span className="italic text-teal" data-id="element-81" data-mp="1r9kcs5mrmb7n">included free</span>
          </h2>
          <p className="mt-3 text-lg font-semibold text-ink-muted" data-id="element-82" data-mp="kv1odspurtoa">
            Bonuses value: <span className="text-red-600 line-through" data-id="element-83" data-mp="funmkseuhfyp">$127</span>
          </p>
        </div>

        <ol className="mt-10 grid gap-8 md:grid-cols-2" data-id="element-84" data-mp="1et542ghnpd03">
          {bonuses.map(b => <li key={b.number} className="flex flex-col overflow-hidden bg-cream sm:rounded-3xl" data-id="element-85" data-mp="1jt9q0m1c2zxp">
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full bg-white" loading="lazy" data-id="element-86" data-mp="15ti31vsua97k" />
              <div className="flex flex-1 flex-col px-5 py-6 sm:px-6" data-id="element-87" data-mp="1ar0hu2tjfinh">
                <div className="flex items-center justify-between gap-3" data-id="element-88" data-mp="w3fa1vlpwv98">
                  <span className="rounded-full bg-navy px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-teal-light" data-id="element-89" data-mp="w1cbgn6i1tsw">Bonus #{b.number}</span>
                  <span className="text-sm font-bold text-ink-muted" data-id="element-90" data-mp="n3sa7e8mzxia">
                    Value: <span className="text-red-600 line-through" data-id="element-91" data-mp="r3av4a0gk8l4">{b.value}</span> <span className="text-cta" data-id="element-92" data-mp="r1q0kke58pn9">FREE</span>
                  </span>
                </div>
                <h3 className="mt-4 font-serif text-2xl font-extrabold leading-snug text-navy" data-id="element-93" data-mp="d6nmvb321vzw">{b.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-ink-muted" data-id="element-94" data-mp="2jsjxcmpgppki">{b.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="px-4 sm:px-0" data-id="element-95" data-mp="2f11vzxjj1mz0">
          <CtaButton label="I want all 5 bonuses free" className="mt-10" data-id="element-96" data-mp="2f00i7lb4mmdl" />
        </div>
      </div>
    </section>;
}